import * as React from 'react';
import { connect } from 'react-redux';

import { Navigate } from 'react-router-dom';

import {
    Button,
    Container,
    Col,
    Row
} from 'reactstrap';

import { ApplicationState } from '../../Store';
import { actionCreators as UserActions, GetAuth0LoggingOut } from '../../Store/User';

import { pathConstants } from '../../Utils/Constants';

import { PortalTextTimeoutMessaging } from '../../Models/Api/strongbox.financialportal';
import { RetrieveTimeoutText, GetPortalText } from '../../Store/PortalAssets';
import { actionCreators as UIStateActions, GetPortalBusyState }  from '../../Store/UIState';

import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator';

type InjectedReduxState = {
    loggingOut: boolean;
    timeoutMessaging?: PortalTextTimeoutMessaging;
    portalBusy: boolean;
};

type InjectedActionCreators = typeof UserActions & typeof UIStateActions;

type SlidingTimeoutProps = {
};

type Props = SlidingTimeoutProps & InjectedReduxState & InjectedActionCreators;

const SlidingTimeoutComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        loggingOut,
        timeoutMessaging,
        SetPortalWorking,
        SetPortalIdle,
        portalBusy,
    } = props;

    const [returnToLogin, setReturnToLogin] = React.useState<boolean>(false);

    React.useEffect(() => {
        const workingMsg = 'slidingtimeout:retrieveresources';

        SetPortalWorking(workingMsg);
        RetrieveTimeoutText()
            .catch(() => {})
            .finally(() => { 
                SetPortalIdle(workingMsg); 
            })
        // I want it to function like componentDidMount so [] is appropriate
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const paragraphs: React.ReactNode[] = React.useMemo(() => {
        const result: React.ReactNode[] = [];

        result.push((
            <h3 key={`slidingWindowTimedOutParagraph1`} style={{ marginTop: '20px' }}>{timeoutMessaging?.sessionExpired || ''}</h3>
        ));

        return result;
    }, [timeoutMessaging])

    if (returnToLogin) {
        return <Navigate to={pathConstants.login} />
    }

    return (
        <>
            {
                !!loggingOut && (
                    <div 
                        style={{ position: 'absolute', width: '100%' }} 
                        className={`lender-region free-content-region content-region control-region control-region-lender`}
                    >
                            <LoadingIndicator active={portalBusy} centerIndicator={true} />
                            <div style={{ height: '100%' }} className={'contained-content'}>
                            <h1>{timeoutMessaging?.loggingOut || ''}</h1>
                        </div>
                    </div>
                )
            }
            {
                !loggingOut && (
                    <div 
                        className={`full-screen-region lender-region content-region control-region control-region-lender`}
                    >
                        <LoadingIndicator active={portalBusy} centerIndicator={true} />
                        <Container fluid>
                            {
                                paragraphs.map((pg, pgIndex) => (
                                    <Row key={`logout-pg-row-${pgIndex}`}>
                                        <Col key={`logout-pg-col-${pgIndex}`}>
                                            {pg}
                                        </Col>
                                    </Row>
                                ))
                            }
                            <Row style={{ marginTop: '40px' }} >
                                <Col>
                                    <Button
                                        className={'small'}
                                        onClick={() => {
                                            setReturnToLogin(true);
                                        }}
                                        color="primary"
                                    >
                                        {timeoutMessaging?.returnToLogin || ''}
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                )
            }
        </>
    );
}

export const SlidingTimeout = connect<InjectedReduxState, InjectedActionCreators, SlidingTimeoutProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            loggingOut: GetAuth0LoggingOut(appState),
            timeoutMessaging: GetPortalText<PortalTextTimeoutMessaging>(appState, 'timeoutMessaging'),
            portalBusy: GetPortalBusyState(appState),
        };

        return result;
    },
    {
        ...UserActions,
        ...UIStateActions,
    }
)(SlidingTimeoutComponent);

